import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NavController, LoadingController, ModalController } from 'ionic-angular';
import {Storage} from '@ionic/storage';
import {ApiService} from '../../app/services/api.service';
import {Config} from '../../app/app.config';
import { AlertController } from 'ionic-angular';
import { GmoPaymentComponent } from '../../components/gmo-payment/gmo-payment';
import { PaygentPaymentComponent } from '../../components/paygent-payment/paygent-payment';
import { OkagepayPaymentComponent } from '../../components/okagepay-payment/okagepay-payment';
import { Localization } from '../../app/app.localization'
import { CustomModalComponent } from '../../components/custom-modal/custom-modal';
import { OkageGoGoogleAnalyticsProvider } from '../../providers/okage-go-google-analytics/okage-go-google-analytics';
import { DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

/**
 * Generated class for the MobileOrderPaymentComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'mobile-order-payment',
  templateUrl: 'mobile-order-payment.html'
})
export class MobileOrderPaymentComponent {

  @ViewChild('paymentForm') paymentForm: any;
  @ViewChild('paygentForm') paygentForm: any;
  @ViewChild('okagepayForm') okagepayForm: any;
  @Input() service:any;
  @Output() returnEvent = new EventEmitter<any>();
  visitor:any;
  voucher:any;
  loading:any;
  payments: any;
  gmopayment: any;
  gmomemberedit: any;
  preventSubmit: boolean;
  shopId: any;
  gmolink: any;
  paygentpayment:any;
  okagepaypayment:any;

  orderArray:any;
  totalAmount;
  disableOption; boolean;

  thanksMessage;

  enableReceiveTime: boolean;
  formatReceivetime: String;

  paymentType; string = "";

  isTakeout: boolean;
  isReserved: boolean;
  paymentModules: any;
  redirectButton: any;
  redirectButtonName: any;

  customThanksViewUrl: any;
  customThanksViewiframeUrlSrc: any;
  storeName: any;

  constructor(
    private storage: Storage,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private _loc: Localization,
    public modalCtrl: ModalController,
    private _apiService: ApiService,
    private _ga: OkageGoGoogleAnalyticsProvider,
    private sanitizer: DomSanitizer) {

    this.storeName = localStorage.getItem("storeName");

    let storeConfig = JSON.parse(localStorage.getItem("configs"));
    this.disableOption = (storeConfig["MOBILEORDER_NOUSE_ADDRESS"] && parseInt(storeConfig["MOBILEORDER_NOUSE_ADDRESS"], 0) > 0);

    let thanksMessage = (storeConfig["MOBILEORDER_COMPLETE_MESSAGE"] && storeConfig["MOBILEORDER_COMPLETE_MESSAGE"].length > 0)
    ? storeConfig["MOBILEORDER_COMPLETE_MESSAGE"]
    : this._loc.t("ご注文ありがとうございます。料理提供までしばらくお待ちください。\n領収書が必要な方は、この画面を係りの者にお見せください");
    this.thanksMessage = thanksMessage.split("\n");
    this.redirectButton = (storeConfig["MOBILEORDER_COMPLETE_VIEW_REDIRECT_BUTTON"]) ? storeConfig["MOBILEORDER_COMPLETE_VIEW_REDIRECT_BUTTON"] : "";
    this.redirectButtonName = (storeConfig["MOBILEORDER_COMPLETE_VIEW_REDIRECT_BUTTON_NAME"]) ? storeConfig["MOBILEORDER_COMPLETE_VIEW_REDIRECT_BUTTON_NAME"] : "";
    this.customThanksViewUrl = (storeConfig["MOBILEORDER_CUSTOM_THANKS_VIEW_URL"] && storeConfig["MOBILEORDER_CUSTOM_THANKS_VIEW_URL"].length > 0)
    ? storeConfig["MOBILEORDER_CUSTOM_THANKS_VIEW_URL"] : ""; 

    this.isTakeout = localStorage.getItem("receiveMethod") === 'takeout';
    this.isReserved = (localStorage.getItem("reserved") == "1") ? true : false;
    if (this.isTakeout) {
      this.enableReceiveTime = (storeConfig["OKAGEGO_CURRENT_WAIT_MINUTES"] == "-1") ? false : true;
    } else {
      this.enableReceiveTime = (storeConfig["OKAGEGO_DELIVERY_WAIT_MINUTES"] == "-1") ? false : true;
    }
    if (Config.build_as_takeout) this.paymentModules = JSON.parse(localStorage.getItem("enablePaymentModules"));
    if (localStorage.getItem("reserved") == "1") {
      this.checkReservedVisitor();
    } else {
      this.checkVisitor();
    }
  }

  redirectSelfToMain() {
    window.location.replace(window.location.origin+"/?client_cd="+localStorage.getItem("client_cd")+"&store_id="+localStorage.getItem("store_id"));
  }

  redirectNewTabToMain() {
    window.open(window.location.origin+"/?client_cd="+localStorage.getItem("client_cd")+"&store_id="+localStorage.getItem("store_id"), "_system");
  }

  calculateTotalAmount() {
    this.totalAmount = 0;
    this.orderArray.forEach(element => {
      this.totalAmount += (element.quantity * element.price);
    });
  }

  countPaymentMethod() {
    let memberID = localStorage.getItem("MemberID");
    let visitor_id = localStorage.getItem("visitor_id");
    let selectPayment = localStorage.getItem("paymentType");

    if (Config.build_as_takeout && this.paymentModules.length > 1) { // オンライン会計を選択した後、支払い方法が複数ある場合は注文後でも選択できるようにする
      let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('支払い方法を\n選択してください'), paymentModules: this.paymentModules }, { showBackdrop: false, enableBackdropDismiss: false })
      modal.onDidDismiss(type => {
        localStorage.setItem('paymentType', type);
        selectPayment = type;
        this.payment(memberID, visitor_id, selectPayment);
      })
      modal.present();
    } else {
      this.payment(memberID, visitor_id, selectPayment);
    }
  }

  payment(memberID: string, visitor_id: string, selectPayment: string){
    this._apiService.getPaymentRequest({"MemberID":memberID, "visitor_id":visitor_id, "store_id":localStorage.getItem("store_id"),"uiid":Config.uiid, "version":"2.5.1", "payment_type": selectPayment, "reserved":localStorage.getItem("reserved")}).subscribe(
      (result) => {
        if (!result.status || parseInt(result.status, 0) !== 1000){
          this.loading.dismiss();
          let message = (result.error_message) ? result.error_message :  this._loc.t("エラーが発生しました");
          let modal = this.modalCtrl.create(CustomModalComponent, { title: this._loc.t('エラー'), subTitle: message, bottomButton: this._loc.t('OK') }, { showBackdrop: false, enableBackdropDismiss: false });
          modal.present();
        }
        else if (result.type && result.type=="paygent"){
          // paygent
          this.paygentpayment = {
            endpoint:result.endpoint,
            request:result.request
          };
          setTimeout(function(){
            console.log(this.paygentForm);
            this.paygentForm.paygentpayment = this.paygentpayment;
            setTimeout(function(){
              this.loading.dismiss();
              this.preventSubmit = true;
              this.paygentForm.submit();
            }.bind(this), 300);
          }.bind(this), 300);
        }
        else if (result.type && result.type=="okagepay"){
          // okagepay
          this.okagepaypayment = {
            endpoint:result.endpoint,
            request:result.request
          };
          setTimeout(function(){
            console.log(this.okagepayForm);
            this.okagepayForm.okagepaypayment = this.okagepaypayment;
            setTimeout(function(){
              this.loading.dismiss();
              this.preventSubmit = true;
              this.okagepayForm.submit();
            }.bind(this), 300);
          }.bind(this), 300);
        }
        else if (result.type && result.type=="nopayment"){
          localStorage.setItem("visitor_id", visitor_id);
          window.location.href = result.redirect_url;
          return;

        }else{
          // gmo
          this.gmopayment = result.request;
          this.gmopayment.endpoint = result.endpoint;
          this.shopId = result.request.ShopID;
          this.gmolink = this._apiService.getGmolink();

          setTimeout(function(){
            this.paymentForm.gmopayment = this.gmopayment;
            setTimeout(function(){
              this.loading.dismiss();
              this.preventSubmit = true;
              this.paymentForm.submit();
            }.bind(this), 300);
          }.bind(this), 300);
        }
      }
    );
  }

  sendPayment(obj){
    // set this variable to false if re-submission is needed
    this.preventSubmit = true;
    this.paymentForm.submit();
  }


  checkVisitor(){
    let hjson = {
      visitor_id: localStorage.getItem("visitor_id"),
      uiid: Config.uiid,
    };
    this.loading = this.loadingCtrl.create();
    this.loading.present();
    this._apiService.checkVisitor().subscribe(
      (result) => {
        if(parseInt(result.status,0) == 1000){

          this.visitor = result.visitor;
          this.voucher = result.voucher;
          this.payments = result.payments;
          this.paymentType = result.type;
          
          // [START set custom thanks view url]
          if (this.customThanksViewUrl && this.customThanksViewUrl.length > 0){
            let url = new URL(
              this.customThanksViewUrl
            );
            // append search
            let additionalParam = `voucher_no=${this.voucher.voucher_no}&visitor_id=${this.visitor.visitor_id}`;
            if (url.search){
              url.search+="&"+additionalParam;
            }else{
              url.search = "?"+additionalParam;
            }
            this.customThanksViewiframeUrlSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url.href);
          }
          // [END set custom thanks view url]

          if (this.payments.length > 0) {
            // this._ga.paymentEvent(true, this.paymentType);
            this._ga.orderHistoryPageView("/"+this.paymentType+"/complete");
          } else {
            //this._ga.paymentEvent(false, this.paymentType);
            if (this.paymentType == "nopayment") {
              this._ga.orderHistoryPageView("/"+this.paymentType+"/deferred");
            } else {
              this._ga.orderHistoryPageView("/"+this.paymentType+"/stop");
            }
          }
          
          if (result.type == "gmo"){
            // if gmo
            if (result.payments.length < 1 && result.gmoPayment && result.gmoPayment.status == 1000){
              //  gmo での会計後に中断したパターンをひろう
              // refresh payment to redirect gmo mp callback
              if(result.gmoPayment.output.Status == "CAPTURE"){
                let gmoQuery = result.gmoPayment.query;
                this._apiService.getGmoMultipayRequest({"MemberID":localStorage.getItem("MemberID"),"visitor_id":localStorage.getItem("visitor_id"), "store_id":localStorage.getItem("store_id"),"uiid":Config.uiid, "version":"2.5.1"}).subscribe(
                  (result) => {
                    window.document.location.href = result.request.RetURL+"?"+gmoQuery;
                    return;
                  }
                );
                return;
              }
            }

            let memberId = localStorage.getItem("MemberID");
            if(!memberId || memberId.length < 1) memberId = this.visitor.visitor_id;
            this._apiService.getGmoMultipayMemberRequest({
              "visitor_id":this.visitor.visitor_id,
              "store_id":localStorage.getItem("store_id"),
              "uiid":Config.uiid,
              "version":"2.5.1"
            },memberId, this.visitor.visitor_id).subscribe(
              (result) => {
                console.log(result);
                if(result.status && parseInt(result.status) == 1000){
                  this.gmomemberedit = result.request;
                  this.shopId = result.request.ShopID;
                }
              }
            );
          }

          // 受け取り予定時間をDate型に成形
          let receivetime = this.visitor.mobile_user_receivetime;
          this.formatReceivetime = receivetime.substring(0, 16);
          this._apiService.getLastOrder(hjson, this._loc.loc).subscribe(
            (result) => {
              this.loading.dismiss();
              this.storage.set('horder.last', result);
              if (typeof result.result !== 'undefined') {
                let tmp = [];
                for(var i = 0; i < result.result.length; i++) {
                  if (result.result[i].quantity > 0) {
                    tmp.push({
                      id: result.result[i].menu_id,
                      name: result.result[i].menu_name,
                      quantity: result.result[i].quantity,
                      price: result.result[i].price,
                      order_datetime: result.result[i].order_datetime
                    });
                  }
                }
                this.orderArray = tmp;
                this.calculateTotalAmount();
              }
            }, (error) => {
              console.log(error);
              this.loading.dismiss();
            });
        }
        else{
          // show error
          console.log(result);
          this.loading.dismiss();
        }

      }
    );
  }
  checkReservedVisitor(){
    let hjson = {
      visitor_id: localStorage.getItem("visitor_id"),
      uiid: Config.uiid,
    };
    this.loading = this.loadingCtrl.create();
    this.loading.present();
    this._apiService.checkReservedVisitor().subscribe(
      (result) => {
        if(parseInt(result.status,0) == 1000){
          this.visitor = result.visitor;
          this.voucher = result.voucher;
          this.payments = result.payments;
          this.paymentType = result.type;
          
          // [START set custom thanks view url]
          if (this.customThanksViewUrl && this.customThanksViewUrl.length > 0){
            let url = new URL(
              this.customThanksViewUrl
            );
            // append search
            let additionalParam = `voucher_no=${this.voucher.voucher_no}&visitor_id=${this.visitor.visitor_id}`;
            if (url.search){
              url.search+="&"+additionalParam;
            }else{
              url.search = "?"+additionalParam;
            }
            this.customThanksViewiframeUrlSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url.href);
          }
          // [END set custom thanks view url]

          if (this.payments.length > 0) {
            // this._ga.paymentEvent(true, this.paymentType);
            this._ga.orderHistoryPageView("/reserved/"+this.paymentType+"/complete");
          } else {
            //this._ga.paymentEvent(false, this.paymentType);
            if (this.paymentType == "nopayment") {
              this._ga.orderHistoryPageView("/reserved/"+this.paymentType+"/deferred");
            } else {
              this._ga.orderHistoryPageView("/reserved/"+this.paymentType+"/stop");
            }
          }
          
          // 予約のgmopayはBR31では未対応のため保留
          // if (result.type == "gmo"){
          //   // if gmo
          //   if (result.payments.length < 1 && result.gmoPayment && result.gmoPayment.status == 1000){
          //     //  gmo での会計後に中断したパターンをひろう
          //     // refresh payment to redirect gmo mp callback
          //     if(result.gmoPayment.output.Status == "CAPTURE"){
          //       let gmoQuery = result.gmoPayment.query;
          //       this._apiService.getGmoMultipayRequest({"MemberID":localStorage.getItem("MemberID"),"visitor_id":localStorage.getItem("visitor_id"), "store_id":localStorage.getItem("store_id"),"uiid":Config.uiid, "version":"2.5.1"}).subscribe(
          //         (result) => {
          //           window.document.location.href = result.request.RetURL+"?"+gmoQuery;
          //           return;
          //         }
          //       );
          //       return;
          //     }
          //   }

          //   let memberId = localStorage.getItem("MemberID");
          //   if(!memberId || memberId.length < 1) memberId = this.visitor.visitor_id;
          //   this._apiService.getGmoMultipayMemberRequest({
          //     "visitor_id":this.visitor.visitor_id,
          //     "store_id":localStorage.getItem("store_id"),
          //     "uiid":Config.uiid,
          //     "version":"2.5.1"
          //   },memberId, this.visitor.visitor_id).subscribe(
          //     (result) => {
          //       console.log(result);
          //       if(result.status && parseInt(result.status) == 1000){
          //         this.gmomemberedit = result.request;
          //         this.shopId = result.request.ShopID;
          //       }
          //     }
          //   );
          // }

          // 受け取り予定時間をDate型に成形
          let receivetime = this.visitor.mobile_user_receivetime;
          this.formatReceivetime = receivetime.substring(0, 16);
          
          this._apiService.getLastReservedOrder(hjson, this._loc.loc).subscribe(
            (result) => {
              this.loading.dismiss();
              this.storage.set('horder.last', result);
              if (typeof result.result !== 'undefined') {
                let tmp = [];
                for(var i = 0; i < result.result.length; i++) {
                  if (result.result[i].quantity > 0) {
                    tmp.push({
                      id: result.result[i].menu_id,
                      name: result.result[i].menu_name,
                      quantity: result.result[i].quantity,
                      price: result.result[i].price,
                      order_datetime: result.result[i].order_datetime
                    });
                  }
                }
                this.orderArray = tmp;
                this.calculateTotalAmount();
              }
            }, (error) => {
              console.log(error);
              this.loading.dismiss();
            });
        }
        else{
          // show error
          console.log(result);
          this.loading.dismiss();
        }

      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/mobile-order-payment/mobile-order-payment.ts